angular.module('avant.filters').filter 'FormattedDate', ->
  (date) ->
    date = new Date(date) if typeof date is 'string'
    ("" + date.getDate() + " / " + (date.getMonth()+1) + " / " + date.getFullYear() )
